export default __webpack_public_path__ + "static/media/news2402297.a867cae3.jpg";